import Quill from './core'
import Toolbar from './modules/toolbar'
import SnowTheme from './themes/snow'

Quill.register(
  {
    'modules/toolbar': Toolbar,
    'themes/snow': SnowTheme,
  },
  true,
)

export default Quill
